export const iconFontAwesomeEmojiFaceLaughWink = (
	<i className="fa-solid fa-face-laugh-wink"></i>
);
